export default __webpack_public_path__ + "static/media/ic_anguilla.88a511c2.svg";